<!--suppress HtmlFormInputWithoutLabel -->
<template>
    <div>
        <slot name="label">
            <label class="flex justify-start items-end truncate" v-if="inputLabel" :for="id" :class="inputLabelClassList">
                <span>{{ inputLabel }}</span>
            </label>
        </slot>
        <div :class="inputWrapperClassList">
            <input :id="id"
                   :disabled="disabled"
                   :type="type"
                   autocomplete="off"
                   :class="inputClassList"
                   :placeholder="placeholder"
                   :value="value"
                   @input="handleChange">
            <div v-if="hasErrorIcon && hasErrors" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                <svg class="h-5 w-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                          clip-rule="evenodd"/>
                </svg>
            </div>
        </div>
        <slot name="errorMessage"></slot>
    </div>
</template>

<script>
export default {
    name: "text-input",

    props: {
        id: {
            type: String,
            required: false,
            default: () => (Math.random() * 99999).toFixed(0)
        },
        type: {
            type: String,
            required: false,
            default: "text"
        },
        value: {
            required: true,
            default: ""
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        inputLabel: {
            type: String,
            required: false,
        },
        placeholder: {
            type: String,
            required: false,
            default: ""
        },
        hasErrors: {
            type: Boolean,
            default: false,
            required: false
        },
        hasErrorIcon: {
            type: Boolean,
            default: true,
            required: false
        },
        inputLabelClassList: {
            type: String,
            required: false,
            default: "block text-sm font-medium leading-5 text-gray-700"
        },
        inputWrapperClassList: {
            type: String,
            required: false,
            default: "relative rounded-md shadow-sm"
        },
        inputClassList: {
            type: String,
            required: false,
            default: function () {
                let classList =
                    "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-300 focus:outline-none focus:shadow-outline-gray focus:border-gray-300 transition duration-150 ease-in-out sm:leading-5";
                if (this.hasErrors) {
                    classList += " border-red-300 focus:ring focus:ring-red-400";
                }
                return classList;
            }
        }
    },
    methods: {
        handleChange (e) {
            this.$emit("input", e.target.value);
        }
    }
};
</script>

<style scoped>

</style>
